<template>
  <div class="card" >
     <a-alert
      :message="data.orderStatus|orderFormat"
      type="info"
      show-icon
      :description="data.orderStatus|orderDFormat"
    />
    <div class="two-card">
      <div class="order-info">
        <div class="title">
          <span>订单信息</span>
        </div>
        <div class="item">
          <label>订单编号：</label><span>{{data.orderNum||'-'}}</span>
        </div>
        <div class="item">
          <label>创建时间：</label><span>{{data.submitDateTimeLabel||'-'}}</span>
        </div>
        <div class="item two">
          <div>
            <label>供应商账号名：</label><span>{{data.supplierAlias||'-'}}</span>
          </div>
          <div>
            <label>供应商账号：</label><span>{{data.supplierAccount||'-'}}</span>
          </div>
        </div> 
        <div class="item two">
          <div>
            <label>渠道商账号名：</label><span>{{data.distributorAlias||'-'}}</span>
          </div>
          <div>
            <label>渠道商账号：</label><span>{{data.distributorAccount||'-'}}</span>
          </div>
        </div> 
        <div class="link-top"></div>
        <div class="item">
          <label>买家：</label><span>{{data.buyer||'-'}}</span>
        </div>
        <div class="item">
          <label>联系方式：</label><span>{{data.buyerPhoneNum||'-'}}</span>
        </div>
        <div class="item">
          <label>买家地址：</label><span>{{data.buyerAddress||'-'}}</span>
        </div>
        <div class="item">
          <label>买家备注：</label><span>{{data.buyerNotes||'-'}}</span>
        </div>
      </div>

      <div class="logistics-info">
        <div class="title"><span>物流信息</span></div>
        <div class="send-goods" v-show="data.orderStatus === 10 || data.orderStatus===52">
          <div class="item">
            <label>快递名称：</label>
            <a-input placeholder="请输入快递公司名" style="width:328px" v-model="logisticsInfo.expressCompany"></a-input>
          </div>
          <div class="item">
            <label>快递单号：</label>
            <a-input placeholder="请输入快递单号" style="width:328px;" v-model="logisticsInfo.trackingNum"></a-input>
          </div>
        </div>
        <div class="logistics-container logistics-height" v-if="data.orderStatus===52">
          <div  class="logistics-item" v-for="(item,index) in logisticsInfoList" :key="index">
            <div class="item first-item">
              <div><label>快递名称：</label><span>{{item.expressCompany||'-'}}</span></div>
              <span class="label-right">{{item.label}}</span>
            </div>
            <div class="item">
              <label>快递单号：</label><span>{{item.trackingNum||'-'}}</span>
            </div>
            <div class="item">
              <label>发货时间：</label><span>{{item.dispatchTime||'-'}}</span>
            </div>
          </div>
        </div>
        <div class="logistics-container" v-else>
            <div  class="logistics-item" v-for="(item,index) in logisticsInfoList" :key="index">
            <div class="item first-item">
              <div><label>快递名称：</label><span>{{item.expressCompany||'-'}}</span></div>
              <span class="label-right">{{item.label}}</span>
            </div>
            <div class="item">
              <label>快递单号：</label><span>{{item.trackingNum||'-'}}</span>
            </div>
            <div class="item">
              <label>发货时间：</label><span>{{item.dispatchTime||'-'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="price-box">
      <div class="price-title">
        <span>订单金额</span>
      </div>
      <div class="price-header">
        <span>商品名称</span>
        <span v-show="orderType!=5&&orderType!=7">渠道价(元)
          <a-tooltip placement="bottom"
          :getPopupContainer="
          triggerNode => {
            return triggerNode.parentNode || document.body;
          }
        ">
            <span slot="title">提供给渠道商的价格</span>
            <a-icon type="exclamation-circle" />
          </a-tooltip>
        </span>
        <span v-show="orderType==2||orderType==3||orderType==4">供货价(元)
          <a-tooltip placement="bottom"
          :getPopupContainer="
          triggerNode => {
            return triggerNode.parentNode || document.body;
          }
        ">
            <span slot="title">渠道商出售的价格</span>
            <a-icon type="exclamation-circle" />
          </a-tooltip>
        </span>
        <span  v-show="!(orderType==2||orderType==3||orderType==4)">进货价(元)
          <a-tooltip placement="bottom"
              :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body;
              }
            ">
            <span slot="title">从供应商进货的价格</span>
            <a-icon type="exclamation-circle" />
          </a-tooltip>
        </span>
        <span>数量</span>
      </div>
      <div class="price-body">
        <span>
					<div class="mdseName">
						<img :src="data.skuImgPath" >
						<div class="mdseName-right">
							<div :title="data.mdseName">{{data.mdseName}}</div>
							<div :title="data.variantNameObject&&data.variantNameObject.values" >
                {{data.variantNameObject&&data.variantNameObject.values|variantF}}
              </div>
						</div>
					</div> </span>
        <span v-show="orderType!=5&&orderType!=7" >{{data.distributePrice|toFixed2}}</span>
        <span v-show="orderType==2||orderType==3||orderType==4">{{data.buyerPrice|toFixed2}}</span>
        <span v-show="!(orderType==2||orderType==3||orderType==4)">{{data.supplyPrice|toFixed2}}</span>
        <span>{{data.quantity||'-'}}</span>
      </div>
      <div class="price-bottom">
        <div v-show="orderType!=5&&orderType!=7">
          <label >合计渠道价金额：</label> 
          <span>¥ {{data.quantity * data.distributePrice|toFixed2}}</span>
        </div>
        <div v-show="!(orderType==2||orderType==3||orderType==4)">
          <label >合计进货价金额：</label>
          <span>¥ {{data.quantity * data.supplyPrice|toFixed2}}</span>
        </div>
        <div v-show="orderType==2||orderType==3||orderType==4">
          <label >合计供货价金额：</label>
          <span>¥ {{data.quantity * data.buyerPrice|toFixed2}}</span>
        </div>
        <div v-show="orderType!=5&&orderType!=6&&orderType!=7">
          <div class="blue" v-show="data.creditStatus=='2'||data.creditStatus=='3'">
            <label >授信扣款：</label> <span>¥{{data.creditAmount|toFixed2}}</span> <br />
            <label >余额扣款：</label> <span>¥{{data.payAmount|toFixed2}}</span>  <br />
          </div>
        </div>
      </div>
      
    </div>
    <div class="btn-container" v-show="btnShow">
        <a-button type="primary" @click="confirm">{{data.orderStatus|btnLabel}}</a-button>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      logisticsInfo:{}
    };
  },
  filters:{
    btnLabel(value){
       switch (value) {
        case 10:
          return "确认发货";
          
        case 40:
          return "确认收货";
          
        case 50:
          return "确认收货";
          
        case 52:
          return "确认发货";
          
      }
    },
    orderFormat(value){
        switch (value) {
          case 10:return "待发货";
          case 20:return "已发货";
          case 30:return "已完成";
          case 40:return "退款退货";
          case 45:return "退款退货";
          case 50:return "换货";
          case 52:return "换货";
          case 54:return "换货";
          case 56:return "换货";
          default:return "";
        }
    },
    orderDFormat(value){
      switch (value) {
        case 40:return "供应商待收货";
        case 45:return "已完成";
        case 50:return "供应商待收货";
        case 52:return "供应商待发货";
        case 54:return "供应商已发货";
        case 56:return "已完成";
        default:return "";
      }
    },
		variantF(value){
      if (!(value instanceof Array)) {
        return "-";
      }
			return value.join("、")
		},
  },
  activated(){
    this.getdata();
  },
  computed: {
    orderType(){
      let orderType =this.$route.query.orderType||"1";
      return orderType;
    },
    logisticsInfoList() {
      return (
        this.data.logisticsInfoList && this.data.logisticsInfoList.reverse()
      );
    },
    btnShow(){
      const showArr = [10,40,50,52];
      return showArr.some(item=>item==this.data.orderStatus)
    }
  },
  methods: {
    confirm(){
      const orderStatus = this.data.orderStatus;
      let params = {orderNum : this.data.orderNum};
      console.log(orderStatus);
      if (orderStatus === 10) {
        params.logisticsInfo = this.logisticsInfo;
        //发货
        this.$http.post("order/dispatch",params).then((res)=>{
          if(res.result){
            this.$message.success('操作成功')
            this.getdata();
          }else{
            this.$message.info(res.message)
          }
        })
      //退货收货
      } else if(orderStatus === 40){
        this.$http.post("order/refund/receive",params).then((res)=>{
          if(res.result){
            this.$message.success('操作成功')
            this.getdata();
          }else{
            this.$message.info(res.message)
          }
        })
        //换货收货
      }else if(orderStatus === 50){
        this.$http.post("order/exchange/receive",params).then((res)=>{
          if(res.result){
            this.$message.success('操作成功')
            this.getdata();
          }else{
            this.$message.info(res.message)
          }
        })
        //换货发货
      }else if(orderStatus === 52){
        params.logisticsInfo = this.logisticsInfo;
        this.$http.post("order/exchange/dispatch",params).then((res)=>{
          if(res.result){
            this.$message.success('操作成功')
            this.getdata();
          }else{
            this.$message.info(res.message)
          }
        })
        
      }
    },
    getdata() {
      let params = {
        orderNum: this.$route.query.id,
      };
      this.$http.get("order/queryRecord",{params}).then((res) => {
        this.data = res.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  margin: 0 24px;
}
.two-card {
  margin: 16px 0;
  min-width: 1034px;
  display: flex;
  justify-content: space-between;
  .order-info,
  .logistics-info {
    padding: 20px 24px;
    background: #fff;
    margin-right: 12px;
    display: inline-block;
    width: calc(98% / 2);
    vertical-align: top;
    .two {
      // display: flex;
      // justify-content: space-between;
      column-count: 2;
    }
    .title {
      font-weight: bold;
      padding-bottom: 10px;
    }
    label {
      font-weight: bold;
      text-align: right;
      display: inline-block;
      width: 98px;
      padding: 6px 0;
    }
  }
}
.price-title {
  padding-bottom: 20px;
  font-weight: bold;
}
.logistics-info {
  margin-right: 0 !important;
  .send-goods{
    .item{
      margin-bottom: 16px;
      label{
        font-weight:400;
        color:rgba(0,0,0,0.85);
      }
    }
    label:before {
      display: inline-block;
      margin-right: 4px;
      color: #f5222d;
      font-size: 14px;
      font-family: SimSun, sans-serif;
      line-height: 1;
      content: "*";
    }
  }
}
.logistics-container::-webkit-scrollbar {
  display: none;
}
.logistics-container {
  font-weight: 400;
  max-height: 304px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  .logistics-item:first-child {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
    label {
      height: 22px;
      font-size: 14px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
    }
  }
  .logistics-item {
    flex: none;
    margin-top: 10px;
    padding: 0 16px;
    height: 114px;
    background: rgba(250, 250, 250, 1);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    label {
      font-weight: 400;
      width: 80px !important;
    }
    .first-item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .label-right {
      height: 32px;
      line-height: 32px;
    }
  }
}
.link-top {
  padding: 0 6px;
  height: 1px;
  border-top: 1px solid rgba(229, 229, 229, 1);
}

.price-box {
  background-color: #fff;
  padding: 20px 24px;
  .price-header {
    font-weight: 500;
    background-color: rgba(250, 250, 250, 1);
  }
  .price-header,
  .price-body {
		vertical-align: middle;
		display: flex;
		align-items: center;
    border-bottom: 1px solid #e8e8e8;
    span {
      padding: 16px 24px;
      display: inline-block;
      width: calc((40%-48px) / 4);
    }
    span:first-child {
      width: 50%;
    }
  }
}
.price-bottom {
  margin-top: 16px;
  padding: 20px 32px;
  text-align: right;
  background: rgba(250, 250, 250, 1);
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  label {
    padding: 4px 0;
    height: 22px;
    line-height: 22px;
  }
  span {
    height: 22px;
    line-height: 22px;
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .blue {
    color: #0254d3;
    color: rgba(2, 84, 211, 1);
  }
}

.mdseName{
  display: flex;
	align-items:center;
	.mdseName-right{
		width: calc(100% - 68px);
		div{
			width: 100%;
			white-space:nowrap;
			overflow:hidden;
			text-overflow:ellipsis;
		}
	}
  img{
    margin-right: 8px;
    width: 60px;
    height: 60px;
  }
}
.btn-container {
  margin-top: 16px;
  min-width: 1034px;
  background: rgba(255, 255, 255, 1);
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>